import { ErrorComponentProps } from "@tanstack/react-router"
import { useEffect, useState } from "react"
import { Card, CardHeader, CardTitle, CardContent, Button } from "@duck/ui"
import { useTar } from "@/modules/i18n"
import * as Sentry from "@sentry/react"
import { Provider as JotaiProvider } from "jotai"
import { ThemeProvider } from "@/contexts/ThemeContext"
import { Layout } from "@/components"
import { ExternalLibs } from "@/components/ExternalLibs/ExternalLibs"

const isMissingAssetError = (error: Error) => {
    return !!error?.message?.match(/Failed to fetch dynamically imported module: https?:\/\/([\w.]*xp-lab\.com|localhost:\d+)\/assets\/[\w-_.]+\.js/)
}

export const ErrorBoundary = ({ error }: ErrorComponentProps) => {
    const { t } = useTar()
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        if (isMissingAssetError(error)) {
            window.location.reload()
            return
        }
        Sentry.captureException(error)
        setIsLoading(false)
    }, [error])

    if (isLoading) {
        return null
    }

    return (
        <JotaiProvider>
            <ExternalLibs />
            <ThemeProvider>
                <Layout>
                    <div className="flex flex-1 items-center justify-center p-6">
                        <Card className="w-full max-w-lg shadow-sm">
                            <CardHeader>
                                <CardTitle>{t('common.error')}</CardTitle>
                            </CardHeader>
                            <CardContent className="space-y-4">
                                <p className="text-sm text-muted-foreground">
                                    {t('common.somethingWentWrongWeveBeenNotified')}
                                </p>
                                <Button onClick={() => window.location.reload()}>{t('common.tryAgain')}</Button>
                            </CardContent>
                        </Card>
                    </div>
                </Layout>
            </ThemeProvider>
        </JotaiProvider>
    )
}
